import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren, Output, EventEmitter } from '@angular/core';
import {
  StepElementTypes,
  StepLayout,
  CustomStepCategoryEnum,
  Funnel,
  CampaignProduct,
  User,
  StepEmulatorDevices,
  DiscountSetting, OfferIntents,
} from '../../../_models';
import {
  AlertService,
  FunnelStepService,
  LoaderService,
  StepEmulatorService,
  StepTemplateService,
} from '../../../_services';
import { FormBuilder, FormGroup } from '@angular/forms';
import { StepsInvalidityFields, InvalidityToStepElementMapping } from '../../step-util';
import { RetentionOffer } from '../../../offer-builder/retention/retention';

@Component({
  selector: 'app-step-form',
  templateUrl: './step-form.component.html',
  styleUrls: ['./step-form.component.scss'],
})
export class StepFormComponent implements OnInit {
  @Input() layout: StepLayout[] = [];
  @Input() stepType: CustomStepCategoryEnum;
  @Input() form: FormGroup;
  @Input() enableFormErrors: boolean;
  @Input() theme: string;
  @Input() isNew: boolean;
  @Input() stepId: string = '';
  @Input() funnelId: string = '';
  @Input() funnel: Funnel;
  @Input() editTemplate: boolean;
  @Input() templateId: string = '';
  @Input() product: CampaignProduct = {} as CampaignProduct;
  @Input() useExternalButtons: boolean;
  @Input() isSurveyStep = false;
  @Input() user: User;
  @Input() activeDevice: StepEmulatorDevices;
  @Input() discount: DiscountSetting;
  @Input() confirmationStepType: string = '';
  @Input() isSingleStepOffer: boolean = false;
  @Input() offerIntent: OfferIntents = null;
  @Input() retentionOffers: RetentionOffer[] = [];
  @Input() isReturnDownsell: boolean = false;
  @Output() discountChange: EventEmitter<DiscountSetting> = new EventEmitter<DiscountSetting>();

  isLoading = false;
  stepElements = StepElementTypes;
  @ViewChildren(
    'stepTextual, stepDiscount, stepMedia, stepSurveyOptions, stepButton, stepTimeDelay, stepDiscountSettings, stepResponseScreen, stepTimeOptions, stepCancellation'
  )
  childComponents: QueryList<ElementRef>;

  constructor(
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected loaderService: LoaderService,
    protected funnelStepService: FunnelStepService,
    protected stepEmulatorService: StepEmulatorService,
    protected stepService: StepTemplateService
  ) {}

  ngOnInit() {
    this.loaderService.loader$.subscribe((state) => {
      this.isLoading = state;
    });
  }

  scrollToFirstErrorComponent() {
    const components = this.childComponents.toArray();
    for (let i = 0; i < components.length; i++) {
      const component = components[i];
      for (const field of StepsInvalidityFields) {
        if (component[field]) {
          const elementType = InvalidityToStepElementMapping[field];

          if (elementType !== null) {
            this.stepEmulatorService.toggleElement(elementType);
          }
        }
      }
    }
  }

  onDiscountChanged(discount: DiscountSetting) {
    this.discount = discount;
    this.discountChange.emit(discount);
  }

}
